var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 7.5H3.75V27.5H36.25V7.5ZM3.75 5C2.36929 5 1.25 6.11929 1.25 7.5V27.5C1.25 28.8807 2.36929 30 3.75 30H36.25C37.6307 30 38.75 28.8807 38.75 27.5V7.5C38.75 6.11929 37.6307 5 36.25 5H3.75Z",
    fill: "#E1E1E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32.5,
    width: 40,
    height: 2.5,
    rx: 1.25,
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.859 14.4913C25.7908 14.5331 24.1671 15.4148 24.1671 17.3699C24.2436 19.5995 26.2162 20.3813 26.25 20.3813C26.2162 20.4232 25.9522 21.4465 25.1703 22.5192C24.5496 23.4433 23.8609 24.375 22.815 24.375C21.8201 24.375 21.4629 23.7592 20.315 23.7592C19.0821 23.7592 18.7333 24.375 17.7895 24.375C16.7436 24.375 16.0037 23.3934 15.3494 22.4781C14.4992 21.2799 13.7766 19.3998 13.7511 17.5945C13.7339 16.6379 13.9213 15.6975 14.3971 14.8988C15.0687 13.7837 16.2677 13.0267 17.5771 13.0018C18.5803 12.9687 19.4731 13.6758 20.0854 13.6758C20.6721 13.6758 21.7691 13.0018 23.0102 13.0018C23.5459 13.0024 24.9745 13.1603 25.859 14.4913ZM20.0005 12.8108C19.822 11.9372 20.315 11.0636 20.7742 10.5063C21.3609 9.83242 22.2876 9.375 23.0867 9.375C23.1378 10.2486 22.8145 11.1054 22.2366 11.7294C21.718 12.4033 20.8252 12.9107 20.0005 12.8108Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopApple);
export default __webpack_public_path__ + "static/media/laptop_apple.36f373424ff39b62aa1cb8a9ab4f19ed.svg";
export { ForwardRef as ReactComponent };